import React, { useContext, useEffect, useRef, useState } from 'react'

import { WappContext } from 'wapplr-react/dist/common/Wapp'
import AppContext from '../../../App/context'
import ModalBase from 'karrierhub-ui/dist/common/src/components/Modal/ModalBase'
import ModalContext from 'karrierhub-ui/dist/common/src/components/Modal/context'
import Menu from 'karrierhub-ui/dist/common/src/components/Menu'
import Button from 'karrierhub-ui/dist/common/src/components/Button'

import { ThemeControlsBase, ThemeControlsIcon } from '../ThemeControlsBase'

export default function ThemeControlsDesktop(props) {

    const context = useContext(WappContext)
    const appContext = useContext(AppContext)
    const { res } = context

    const [mounted, setMounted] = useState(false)
    const open = useRef(false)
    const container = useRef()
    const tipPaper = useRef()

    useEffect(() => {
        setMounted(true)
    }, [])

    function setOpen(value) {
        if (open.current !== value) {
            open.current = value
            if (value) {
                if (container.current) {
                    container.current.classList.add(classNames.themeControlsButtonOpen)
                }
            } else {
                if (container.current) {
                    container.current.classList.remove(classNames.themeControlsButtonOpen)
                }
            }
        }
    }

    const {
        classNames,
        themeRef,
        size
    } = props

    const popoverRef = useRef({})
    const iconRef = useRef({})

    return (
        <ModalBase
            open={mounted}
            keepMounted={true}
            isMounted={mounted}
            disableScroll={false}
            BackdropComponent={() => null}
        >
            <div
                ref={container}
                className={classNames.themeControlsButton}
            >
                <ModalContext.Provider value={{ portalElement: null }}>
                    <Menu
                        PopoverProps={{
                            getPortalElement: () => container.current,
                            AnchorComponent: Button,
                            AnchorComponentProps: {
                                icon: <ThemeControlsIcon
                                    mode={res.wappResponse.store.getState('karrierhubUi.mode') || 'auto'}
                                    effect={({ actions }) => {
                                        iconRef.current.actions = actions
                                    }}
                                />,
                                tip: appContext.menus.themeControlsMenu,
                                variant: 'contained',
                                size,
                                TipPaperProps: {
                                    ref: tipPaper
                                },
                                TipPopoverProps: {
                                    getPortalElement: () => container.current
                                }
                            },
                            effect: ({ popper }) => {
                                popoverRef.current.popper = popper
                            },
                            onOpen: async () => {
                                setOpen(true)
                                await new Promise((resolve) => setTimeout(resolve, 500))
                                popoverRef.current.popper.actions.update()
                            },
                            onClose: () => {
                                setOpen(false)
                            },
                            popperOptions: {
                                modifiers: [{
                                    name: 'preventOverflow',
                                    options: {
                                        padding: { left: 0, right: 16, top: 0, bottom: 0 }
                                    }
                                }]
                            }
                        }}
                        PaperProps={{
                            size: 'menu'
                        }}
                        menu={[
                            {
                                Component: ThemeControlsBase,
                                classNames,
                                themeRef,
                                iconRef,
                                size: 'default'
                            }
                        ]}
                    />
                </ModalContext.Provider>
            </div>
        </ModalBase>
    )
}
